import { defineMessages } from 'react-intl';

const messages = defineMessages({
  email: {
    description: 'advancedSearch.orders.filters.email',
    defaultMessage: 'Email',
    id: 'EQZal3',
  },
});

export default messages;
